import { Address } from './Address';
import { Contact } from './Contact';
import { DiscardableModel } from './DiscardableModel';
import { EmailTemplateLink } from './EmailTemplate';
import { FormTemplateLink } from './FormTemplate';
import { Employee } from './Employee';
import { EmployeeRequirement } from './EmployeeRequirement';
import { ErroredModel } from './ErroredModel';
import { Field } from './FieldCommon';
import { Integration } from './Integration';
import { TaggableModel } from './Tag';
import { Task } from './Task';
import { PaginationMeta } from './pagination';

export enum EventStatus {
  PLANNING = 'Planning',
  SCHEDULED = 'Scheduled',
  IN_PROGRESS = 'In progress',
  COMPLETE = 'Complete',
  CANCELLED = 'Cancelled',
}

const EVENT_STATUS_COLORS: Record<EventStatus, string> = {
  [EventStatus.PLANNING]: '#c0c0c0',
  [EventStatus.SCHEDULED]: '#42A5F5',
  [EventStatus.IN_PROGRESS]: '#AD49E1',
  [EventStatus.COMPLETE]: '#35B23D',
  [EventStatus.CANCELLED]: '#c0c0c0',
};

export function eventBaseColor(status: EventStatus) {
  return EVENT_STATUS_COLORS[status];
}
export interface ConflictEmployeeEvent {
  event_uuid: string;
  event_display_name: string;
}

export type AttendanceStatus = 'pending' | 'accepted' | 'declined';

export interface EventEmployee {
  employee: Employee;
  status: AttendanceStatus;
  conflict_employee_events?: ConflictEmployeeEvent[];
  employee_role_uuid?: string;
  employee_role_value?: string;
}

export type Event = ErroredModel &
  TaggableModel &
  DiscardableModel & {
    uuid: string;
    new_record?: boolean;
    start_at: string;
    end_at: string;
    status: EventStatus;
    display_name: string;
    account_uuid: string;
    account_name: string;
    account_display_name: string;
    account_code?: string;
    event_template_uuid?: string;
    event_template_name?: string;
    parent_uuid?: string;
    parent_name?: string;
    type_uuid: string;
    type_value: string;
    location_uuid: string;
    location_value: string;
    calendar_event_id: string;
    outlook_calendar_event_id: string;
    tasks: Task[];
    fields: Field[];
    event_email_templates: EmailTemplateLink[];
    integrations: Integration[];
    event_employees: EventEmployee[];
    event_form_templates: FormTemplateLink[];
    employee_requirements?: EmployeeRequirement[];
    contacts: Contact[];
    name: string;
    address?: Address;
    is_full_day?: boolean;
    multi_child: boolean;
    multi_parent: boolean;
    children: Event[];
    event_template_parent_child_uuid?: string;
    event_template_parent_child_offset?: number;
  };

export type EventResponse = {
  data: Event[];
  meta: PaginationMeta;
};

export interface EventItemQueryParams {
  account?: string;
  template?: string;
}

export enum EventTimeSpan {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  WEEK = 'week',
  UPCOMING = 'upcoming',
}
